var React = require('react');

function IconCircleEmpty (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z","fill":"currentColor","fillRule":"nonzero"}));
}

IconCircleEmpty.defaultProps = {"width":"24","height":"24"};

module.exports = IconCircleEmpty;

IconCircleEmpty.default = IconCircleEmpty;
